import {waitCondition} from './wait';

/**
 * get a promise that resolves when an image is loaded. Simple version that works on modern
 * browsers, without the need of external big libraries.
 *
 * @param {HTMLImageElement|String} img the image to monitor, expressed as Image object or as a URL
 * string
 * @returns {Promise<boolean>} Resolves with true when the load is successful, with false if there
 * is an error
 */
function onImageLoad(img) {
	return new Promise(async (resolve) => {
		const getFinalCondition = (i) => () => i.complete && i.naturalWidth;
		let src = img;
		if (img instanceof HTMLImageElement) {
			const condition = () => img.currentSrc && img.currentSrc.length;
			await waitCondition(condition);
			if (getFinalCondition(img)()) {
				resolve(true);
				return;
			}
			src = img.currentSrc;
		}
		const checkImg = new Image();
		let clean = null;
		const onLoad = async () => {
			await waitCondition(getFinalCondition(checkImg));
			clean();
			resolve(true);
		};
		const onError = () => {
			clean();
			resolve(false);
		};
		clean = () => {
			checkImg.removeEventListener('load', onLoad);
			checkImg.removeEventListener('error', onError);
		};
		checkImg.addEventListener('load', onLoad);
		checkImg.addEventListener('error', onError);
		checkImg.src = src;
	});
}

export {onImageLoad};
